var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-stream-info-container ticker-wrap"},[_c('div',{staticClass:"ticker-move"},[_c('div',{staticClass:"ticker-item"},[_vm._v("Live stream starts at "+_vm._s(_vm.formattedStartTime))])])])}
var staticRenderFns = []

export { render, staticRenderFns }